interface LogoProps {
  size?: number
  compact?: boolean
  inverse?: boolean
}

/** CX Agent product mark. Legacy exports remain below for compatibility. */
export function CXAgentMark({ size = 36 }: LogoProps) {
  return (
    <img
      src="/assets/cx-mark-v2.png"
      width={size}
      height={size}
      alt="CX Agent"
      style={{ display: 'block', objectFit: 'contain', flexShrink: 0 }}
    />
  )
}

export function CXAgentWordmark({ size = 42, compact = false, inverse = false }: LogoProps) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: compact ? 8 : 11, minWidth: 0 }}>
      <CXAgentMark size={size} />
      {!compact && (
        <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0, lineHeight: 1 }}>
          <span style={{
            color: inverse ? '#FFFFFF' : 'var(--ink)',
            fontSize: Math.max(16, size * 0.46),
            fontWeight: 700,
            letterSpacing: '-0.035em',
            whiteSpace: 'nowrap',
          }}>
            CX Agent
          </span>
          <span style={{
            color: inverse ? 'rgba(255,255,255,.62)' : 'var(--ink-3)',
            fontSize: Math.max(10, size * 0.27),
            fontWeight: 500,
            letterSpacing: '-0.01em',
            marginTop: 5,
            whiteSpace: 'nowrap',
          }}>
            Powered by Helix
          </span>
        </span>
      )}
    </div>
  )
}

// Backwards-compatible names used across the current frontend.
export const HelixMark = CXAgentMark
export const HelixWordmark = CXAgentWordmark

interface AvatarProps {
  name?: string
  size?: number
  gradient?: boolean
}

export function Avatar({ name = 'A', size = 28, gradient = false }: AvatarProps) {
  const initials = name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: gradient ? 'var(--grad-cx)' : 'var(--bg-sunken)',
      color: gradient ? 'white' : 'var(--ink)',
      border: gradient ? 'none' : '1px solid var(--line)',
      fontSize: size * 0.4, fontWeight: 600, letterSpacing: '-0.02em',
      flexShrink: 0,
    }}>
      {initials}
    </div>
  )
}
